// Utils & misc
import cn from '../../../utils/cn';

// Styles
import styles from './DateRangePickerFooter.module.css';

/**
 * DateRangePickerFooter component - Footer for date picker with actions and content
 * @param {object} props
 * @param {React.ReactNode} [props.children = null] - Content to display in the footer
 * @param {React.ReactNode} [props.timeRange = null] - Time range to display in the footer
 * @param {React.ReactNode} [props.actions = null] - Action buttons to display
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} DateRangePickerFooter component
 */
function DateRangePickerFooter({
  children = null,
  timeRange = null,
  actions = null,
  className = '',
}) {
  return (
    <div className={styles.container}>
      <div className={cn([styles.footer, className])}>
        {children ? (
          <div className={styles.content}>
            {children}
          </div>
        ) : null}

        <div className={styles.actions}>
          <div className={styles['actions-sidebar']} />
          <div className={styles['actions-content']}>
            <div className={styles['actions-content-outer']}>
              {timeRange}
            </div>
            <div className={styles['actions-content-inner']}>
              {actions}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DateRangePickerFooter;
